module.exports = __webpack_public_path__ + "static/img/wood12.479381f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood12.jpg
// module id = CVxf
// module chunks = 0